import SearchIcon from "@mui/icons-material/Search";
import {
  Box,
  IconButton,
  InputAdornment,
  Paper,
  TextField,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import CustomButton from "../components/Button";
import CustomCardList from "../components/Cards";
import PageLoader from "../components/Loader";
import Title from "../components/PageTitle";
import CustomTable from "../components/Table";
import { useToast } from "../components/Toast";
import useIsMobile from "../Hooks/useIsMobile";
import apiService from "../Services/api.service";
const ClinicTable = () => {
  const [clinics, setClinics] = useState([]);
  const [searchParams, setSearchParams] = useSearchParams();
  const [searchQuery, setSearchQuery] = useState(searchParams.get("q") || "");
  const [filteredClinics, setFilteredClinics] = useState([]);
  const [page, setPage] = useState(Number(searchParams.get("page")) || 1);
  const [rowsPerPage, setRowsPerPage] = useState(
    Number(searchParams.get("limit")) || 10
  );
  const [totalCount, setTotalCount] = useState(0);
  const navigate = useNavigate();
  const location = useLocation();
  const isMobile = useIsMobile();
  const [Loader, isLoader] = useState(false);
  const Toast = useToast();
  const auth = localStorage.getItem("token");
  const entityId = localStorage.getItem("entityId");
  const [typingTimeout, setTypingTimeout] = useState(null);
  const updateURLParams = (newFilters) => {
    setSearchParams({
      q: newFilters.searchQuery || "",
      page: newFilters.page || 1,
      limit: newFilters.rowsPerPage || 10,
    });
  };
  useEffect(() => {
    updateURLParams({
      page,
      rowsPerPage,
    });
  }, [page, rowsPerPage]);
  useEffect(() => {
    getClinics(entityId, page, rowsPerPage);
  }, [page, rowsPerPage]);

  const getClinics = async (entityId, page, limit) => {
    isLoader(true);
    try {
      // Call API
      const { clinics, totalItems } = await apiService.fetchClinic(
        auth,
        entityId,
        page,
        limit
      );
      const mappedClinics = clinics.map((clinic) => ({
        ...clinic,
        id: clinic.id,
      }));

      setClinics(mappedClinics);
      setFilteredClinics(mappedClinics);
      setTotalCount(totalItems);
    } catch (error) {
      Toast.error("Error while Fetching");
    } finally {
      isLoader(false);
    }
  };

  useEffect(() => {
    if (typingTimeout) clearTimeout(typingTimeout);

    const timeout = setTimeout(async () => {
      try {
        const { clinics, totalItems } = await apiService.fetchClinic(
          auth,
          entityId,
          page,
          10,
          searchQuery
        );
        const mappedClinics = clinics.map((clinic) => ({
          ...clinic,
          id: clinic.id,
        }));
        setTotalCount(totalItems);
        setFilteredClinics(mappedClinics);
      } catch (error) {
        console.error("Error fetching Kiosk:", error);
        Toast.error("Error while Fetching");
      }
    }, 500); // 500ms debounce

    setTypingTimeout(timeout);

    // Cleanup
    return () => clearTimeout(timeout);
  }, [searchQuery, page]);
  const handleSearch = (event) => {
    const keyword = event.target.value.toLowerCase();
    setSearchQuery(keyword);
  };

  const handlePageChange = (event, newPage) => {
    setPage(newPage + 1);
  };

  const handleRowsPerPageChange = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(1);
  };


  const handleCardClick = (clinic) => {
    navigate(`/dashboard/clinic/cinicDetails/${clinic.doctorId}`, {
      state: { doctorId: clinic.doctorId, clinicName: clinic.name  },
    });
  };

  const handleRowClick = (row) => {
    navigate(`/dashboard/clinic/clinicDetails/${row.doctorId}`, {
      state: { doctorId: row.doctorId,clinicName: row.name  },
    });
  };

  const columns = [
    { field: "name", headerName: "Name", align: "center" },
    { field: "city", headerName: "City", align: "center" },

    {
      field: "totalScans",
      headerName: "Total Scans",
      align: "center",
    },
  ];

  return (
    <div>
      <Paper sx={{ padding: 2 }}>
        <Title text="Clinics" />
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            marginBottom: 2,
          }}
        >
          <TextField
            label="Search"
            variant="outlined"
            value={searchQuery}
            onChange={handleSearch}
            fullWidth
            sx={{ marginBottom: 2, marginTop: 3 }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton>
                    <SearchIcon />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        </Box>

        {isMobile ? (
          <CustomCardList
            fields={[
              { label: "name", key: "name" },
              { label: "city", key: "city" },
            ]}
            data={filteredClinics}
           onCardClick={handleCardClick}
            page={page - 1} // Adjust for zero-based indexing for `CustomTable`
            rowsPerPage={rowsPerPage}
            totalCount={totalCount}
            onPageChange={handlePageChange}
            onRowsPerPageChange={handleRowsPerPageChange}
          />
        ) : (
          <CustomTable
            columns={columns}
            data={filteredClinics}
            actions={[
              {
                Component: CustomButton,
                props: { text: "Details", width: "90px", height: "40px" },
                onClick: handleRowClick,
              },
            ]}
            page={page - 1} // Adjust for zero-based indexing for `CustomTable`
            rowsPerPage={rowsPerPage}
            totalCount={totalCount}
            onPageChange={handlePageChange}
            onRowsPerPageChange={handleRowsPerPageChange}
          />
        )}
      </Paper>
      {Loader && <PageLoader />}
    </div>
  );
};

export default ClinicTable;
